/*       */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';
import Chart from './Chart/Chart';
import PageNotAllowed from '../ErrorPages/PageNotAllowed';
/**
 * Defines the routes for the Classes views
 */
class AnalyticsRoute extends Component {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
        userProfile: PropTypes.object,
    };

    /**
     * @override
     */
    render() {
        const { match } = this.props;
        const { permissions, isAdmin } = this.props.userProfile;
        const permissionsSet = new Set(permissions || []);
        const canView = isAdmin || permissionsSet.has('analytics.superAnalytics'); //analitycs is
        if (!canView) {
            return <PageNotAllowed title="Affectli Intelligence" />;
        }
        return (
            <Switch>
                <Route path={`${match.url}`} exact component={Chart} />
            </Switch>
        );
    }
}

export default connect(state => ({
    userProfile: state.user.profile,
}))(AnalyticsRoute);
